"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Intent = void 0;
/**
 * Represents intent information
 */
var Intent = /** @class */ (function (_super) {
    __extends(Intent, _super);
    function Intent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Intent";
        /**
         * The identity id
         */
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        /**
         * The intent reference id
         */
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        /**
         * The name of the intent
         */
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        /**
         * Detailed description about the intent
         */
        _this.appendent = function () {
            _this.push(function (_) { return "appendent"; });
        };
        /**
         * The utterance dictionary. The key is a language key and the value is a list of utterances
         */
        _this.utterance = function () {
            _this.push(function (_) { return "utterance"; });
        };
        /**
         * The list of labels of the intent
         */
        _this.labelList = function () {
            _this.push(function (_) { return "labelList"; });
        };
        /**
         * The version of the intent
         */
        _this.version = function () {
            _this.push(function (_) { return "version"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Intent;
}(Array));
exports.Intent = Intent;
//# sourceMappingURL=Intent.js.map